<style>


  /* Chrome, Safari, Edge, Opera */
  input#code::-webkit-outer-spin-button,
  input#code::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input#code[type=number] {
    -moz-appearance: textfield;
  }

  input#code {
    height: 40px;
    font-size: 30px;
    text-align: center;
    letter-spacing: 14px;
  }

  .ltr_ecommerce .bh_back {
    margin: 0;
  }

  .bh_left {
    justify-content: center;
  }

</style>
<template>
  <div>
      <div
      style="padding-top: 20px"
      v-if="loader().WEBVIEW_MODE === loader().const.ECOMMERCE"
      ></div>
    <div class="basket_inner">
      <!-- <div @click="disable()" class="pu_b_close"></div> -->
      <div class="basket_head">
        <div class="bh_left">
          <a
            class="bh_back"
            @click="close()"
          >
            <img
              :src="require('@/assets/img/facebook/back_str.svg')"
              alt="back"
            >
          </a>
          <div class="bh_title">{{ text('screen_form_title') }}</div>
        </div>
      </div>

      <div class="pu_bottom_inner scroll_y" style="min-height: 90vh; ">
        <div style="text-align: center">
          <div style="padding: 10px">
            <h3>{{ text('verify_phone') }}</h3>
            <br>
            <span style="display: block">{{ text('verify_phone_code_sent') }}</span>
            <br>
            <span style="display: block">{{ text('verify_phone_enter_code') }}</span>
          </div>
          <span class="input input_style" style="width: 50%; display: inline-block">
                            <form v-on:submit.prevent="check()">
                              <input
                                class="input__field input__field--ruri"
                                id="code"
                                type="number"
                                v-model="code"

                              />
                            </form>

                          <div class="input__label" v-show="code.length === 0">
                            <span class="input__label-content" style="pointer-events: none">{{ text('verify_phone_code') }}</span>
                          </div>
                        </span>

          <div v-if="!$store.getters.loading[SEND_SMS]">
            <small style="margin-top:5px; color: #b0b0b0;">{{ text('verify_phone_code_missing')
              }}</small>
            <small
              :style="{textDecoration: smsTimeout > 0 ? 'none' : 'underline', cursor: smsTimeout > 0 ? '' : 'pointer'}"
              @click="send()"
              style="margin-top:5px; color: #b0b0b0; display: block">
              <template v-if="smsTimeout > 0">{{ text('verify_phone_code_missing_resend_after',
                {time: smsTimeout}) }}
              </template>
              <template v-else>{{ text('verify_phone_code_missing_resend') }}</template>
            </small>
          </div>
          <div>
              <a @click="check()" class="fbb_btn"
                  style="margin-top: 20px; margin-bottom: 20px; cursor: pointer; display: inline-block; width: 50%"
                  v-if="code.length === 4">
                <template v-if="this.loading.check">
                  <svg class="svg_anim" version="1.1" viewBox="0 0 130.2 130.2"
                        xmlns="http://www.w3.org/2000/svg">
                    <circle class="path circle" cx="65.1" cy="65.1" fill="none" r="57.1"
                            stroke="#fff"
                            stroke-miterlimit="10" stroke-width="7"/>
                  </svg>
                </template>
                <template v-else>
                  OK
                </template>
              </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapGetters} from 'vuex'
  import {MAKE_ORDER, SEND_SMS} from '@/store/actions.type'
  import api from '@/api'
  import Noty from 'noty'
  import axios from 'axios'
  import {SET_MODAL} from '@/store/mutations.type'

  export default {
    name: 'SMSCheck',
    data() {
      return {
        code: '',
        loading: {
          check: false
        },

        SEND_SMS
      }
    },
    props: {
      phone: String,
      makeOrderPayload: Object
    },

    mounted() {
      // this.$store.subscribe(mutation => {
      //   if (mutation.type === SET_MODAL && mutation.payload.modal === 'sms') {
      //     if (mutation.payload.status === true) {
      //       this.send()
      //     }
      //   }
      // })
      this.send()
    },

    watch: {
      code(code) {
        if (code.length > 3) {
          this.code = code.substring(0, 4)
        }
      }
    },

    methods: {

      // disable() {
      //   this.$store.commit(SET_MODAL, {modal: 'sms', status: false})
      // },

      send() {
        if (this.smsTimeout <= 0) {
          this.$store.dispatch(SEND_SMS, {phone: this.phone})
        }
      },

      async check() {
        if (this.loading.check) {
          return
        }
        this.loading.check = true
        let confirmed = await this.checkCode()
        if (confirmed) {
          // this.disable()
          this.$store.dispatch(MAKE_ORDER, this.makeOrderPayload)
          this.close()
        } else {
          new Noty({
            type: 'error',
            theme: 'sunset',
            text: this.text('verify_phone_wrong_code'),
            timeout: 2000
          }).show()
        }
        this.loading.check = false
      },

      checkCode() {
        return axios({
          method: 'POST',
          url: api.sms.check.url(),
          data: {
            phone: this.phone,
            code: this.code
          }
        }).then(response => response.data.confirmed)
      },

      close() {
        this.$emit('closeSms');
      }

    },

    computed: {
      ...mapGetters(
        ['smsPayload', 'smsTimeout'])
    }
  }
</script>

<style scoped>

</style>
